import addError from '../../../utils/error.jsx';
import * as getChat from './get-chat';
// import * as getNotifications from '../../notifications/actions/get';
// import { NotificationsCentreState } from 'src/components/NotificationsCentre/NotificationsCentreState';

export function request(chatId) {
    return {
        type: 'TRADER_CHAT_UNASSIGN_CHAT_REQUEST',
        chatId,
    };
}

export function error(chatId, errors) {
    addError(errors);

    return {
        type: 'TRADER_CHAT_UNASSIGN_CHAT_ERROR',
        chatId,
        errors,
    };
}

export function finish(chatId) {
    return (dispatch) => {
        dispatch(getChat.request(chatId));

        dispatch({
            type: 'TRADER_CHAT_UNASSIGN_CHAT_FINISH',
            chatId,
        });
    };
}
